import { Outlet } from 'react-router-dom'
import { AgencyProvider } from '@/features/agencies/providers/AgencyProvider'
import { AgencyAssetsProvider } from '@/features/agencies/contexts/AgencyAssetsContext'

/**
 * AppShell - Wrapper for /app/* routes
 *
 * Applies agency-specific providers (branding, theme, assets) only to authenticated app routes.
 * Public routes (landing page) bypass this wrapper and use default Kopro branding.
 */
export function AppShell() {
  return (
    <AgencyProvider>
      <AgencyAssetsProvider>
        <Outlet />
      </AgencyAssetsProvider>
    </AgencyProvider>
  )
}
